import { useFunctionPermissions } from './useFunctionPermissions';

export type CrudPermissionCodes = {
  view?: string;
  create?: string;
  edit?: string;
  delete?: string;
  import?: string;
};

export const useCrudPermissions = (codes: CrudPermissionCodes) => {
  const { can, loading } = useFunctionPermissions();

  return {
    loading,
    canView: codes.view ? can(codes.view, 'view') : true,
    canCreate: codes.create ? can(codes.create, 'create') : false,
    canEdit: codes.edit ? can(codes.edit, 'edit') : false,
    canDelete: codes.delete ? can(codes.delete, 'delete') : false,
    canImport: codes.import ? can(codes.import, 'import') : false,
  };
};
